module.exports = __webpack_public_path__ + "static/img/qs-logo.90d91dcb.png";